import moment from "moment";

interface FilterData {
  path: string;
  filters: any;
  date: string;
}

const FILTERS_STORAGE_KEY = "filtersData";
const FILTER_EXPIRATION_MINUTES = 30;

const getCurrentPath = () => window.location.pathname + window.location.search;

const getStoredFilters = (): FilterData[] => {
  try {
    const storedFilters = localStorage.getItem(FILTERS_STORAGE_KEY);
    if (!storedFilters) {
      return [];
    }

    const parsedFilters = JSON.parse(storedFilters);
    return Array.isArray(parsedFilters) ? parsedFilters : [];
  } catch {
    localStorage.removeItem(FILTERS_STORAGE_KEY);
    return [];
  }
};

const setStoredFilters = (filters: FilterData[]) => {
  try {
    localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(filters));
  } catch {
    localStorage.removeItem(FILTERS_STORAGE_KEY);
  }
};

export function saveFiltersDataToLocalStorage(filterData: any) {
  const currentTime = moment().valueOf().toString();
  const filtersArray = getStoredFilters().filter(
    (filter) => filter.path !== getCurrentPath()
  );
  const fullPath = getCurrentPath();

  const updatedData = { ...filterData };
  delete updatedData.status;

  const newEntry: FilterData = {
    path: fullPath,
    date: currentTime,
    filters: {
      ...updatedData,
      sortBy: "",
      sortType: "",
      page: 1,
      limit: updatedData.limit ?? 10,
      viewType: updatedData.viewType ?? "list",
    },
  };

  setStoredFilters([...filtersArray, newEntry]);
}

export function getFiltersDataFromLocalStorage(): FilterData | undefined {
  const fullPath = getCurrentPath();
  return getStoredFilters().find((filter) => filter.path === fullPath);
}

export function removeExpiredFiltersFromLocalStorage() {
  const storedFilters = getStoredFilters();
  const updatedFilters = storedFilters.filter((filter) => !shouldClearFilter(filter.date));

  if (updatedFilters.length !== storedFilters.length) {
    setStoredFilters(updatedFilters);
  }
}

function shouldClearFilter(time: string): boolean {
  const filterTimeMoment = moment(parseInt(time, 10));
  const minutesSinceDismissed = moment().diff(filterTimeMoment, "minutes");
  return minutesSinceDismissed >= FILTER_EXPIRATION_MINUTES;
}
